import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useQuery } from '@tanstack/react-query';
import { getPlatformCompanies } from 'api/platformCompanies';
import { platformCompaniesKeys } from 'api/queryKeys';
import { Flex, Line, Spinner } from 'components';
import { BackButton } from 'components/BackButton';
import { Button } from 'components/_form';
import { H1 } from 'components/Typography/Typography';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Wrapper } from '../CompanyAdministrationView/CompanyAdministrationView.styled';
import { PlatformCompaniesTable } from './components/PlatformCompaniesTable';

export const PlatformCompaniesView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data, isLoading } = useQuery({
    queryKey: platformCompaniesKeys.all(),
    queryFn: () => getPlatformCompanies()
  });

  const companies = data?.data ?? [];

  return (
    <Wrapper mb={94} flexDirection="column">
      <Flex width="100%" alignItems="center">
        <BackButton />
        <H1 m={2} variant={['h3', 'h2']} textTransform="uppercase">
          {t('platform.title')} | {t('platform.companies.title')}
        </H1>
        <Flex ml="auto">
          <Button
            variant="eucalyptus"
            minWidth="200px"
            minHeight="38px"
            onClick={() => navigate('/app/platform/companies/new')}
          >
            <FontAwesomeIcon icon={faPlus} style={{ marginRight: '8px' }} />
            {t('platformCompanies.addCompany')}
          </Button>
        </Flex>
      </Flex>
      <Line />
      {isLoading ? (
        <Spinner />
      ) : (
        <PlatformCompaniesTable companies={companies} />
      )}
    </Wrapper>
  );
};
